"use strict";

const domElementExistByQuery = (domElement) => {
	return (document.querySelector(domElement) === null ? false : true);
}

export {
	domElementExistByQuery
};